import React, { useState, useEffect, useContext } from 'react';
import { Grid, FormLabel, FormHelperText } from '@material-ui/core';
import { DatePicker, SecondaryButton } from '../../../../Core/FormInput';
import { postWorkshopShiftAssignmentsDelete } from '../../../../Core/Service/WorkshopShiftSchedule-service';
import AppContext from '../../../../App/AppContext';
import moment from 'moment';

const UnassignTechnicianModal = (props) => {
    const { onClose, shiftID, shiftName, branchName, branchID, defaultStartDate, defaultEndDate, existingAssignment, technicianName } = props;
    const { showToast } = useContext(AppContext);

    const [state, setState] = useState({
        startDate: '',
        endDate: '',
        technicianUserID: ''
    });
    const [errors, setErrors] = useState({});
    const [isBtnLoader, setIsBtnLoader] = useState(false);

    useEffect(() => {
        setState({
            technicianUserID: existingAssignment?.technicianUserID ? String(existingAssignment.technicianUserID).toLowerCase() : '',
            startDate: defaultStartDate ? moment(defaultStartDate).format('YYYY-MM-DD') : '',
            endDate: defaultEndDate ? moment(defaultEndDate).format('YYYY-MM-DD') : ''
        });
    }, [existingAssignment, defaultStartDate, defaultEndDate]);

    const handleInput = (e) => {
        const { name, value } = e.target;
        setState((prev) => ({ ...prev, [name]: value }));
        if (errors[name]) {
            setErrors((err) => ({ ...err, [name]: null }));
        }
    };

    const validate = () => {
        const tempErrors = {};
        if (!state.startDate) tempErrors.startDate = 'Start Date is required';
        if (!state.endDate) tempErrors.endDate = 'End Date is required';
        if (state.startDate && state.endDate && state.startDate > state.endDate) {
            tempErrors.endDate = 'End Date must be after Start Date';
        }
        setErrors(tempErrors);
        return Object.keys(tempErrors).length === 0;
    };

    const handleUnassign = async () => {
        if (!validate()) return;

        setIsBtnLoader(true);
        try {
            const payload = {
                ShiftID: shiftID,
                StartDate: moment.utc(state.startDate).startOf('day').toISOString(),
                EndDate: moment.utc(state.endDate).startOf('day').toISOString(),
                TechnicianUserID: state.technicianUserID || '00000000-0000-0000-0000-000000000000',
                BranchID: branchID ? parseInt(branchID, 10) : null
            };

            const res = await postWorkshopShiftAssignmentsDelete(payload);
            if (res.success || res.data?.success) {
                showToast(res.data?.message || res.message || 'Technician unassigned successfully', 'success');
                onClose(true);
            } else {
                showToast(res.data?.message || res.message || 'Failed to unassign technician', 'error');
            }
        } catch (error) {
            console.error('Error unassigning technician:', error);
            showToast('An error occurred while unassigning', 'error');
        } finally {
            setIsBtnLoader(false);
        }
    };

    return (
        <Grid container spacing={2} style={{ padding: '8px' }}>
            {/* ── Context Info ── */}
            {(branchName || shiftName || technicianName) && (
                <Grid item xs={12}>
                    <div
                        style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            paddingBottom: 8,
                            borderBottom: '1px solid #E5E7EB',
                            marginBottom: 4,
                            justifyContent: 'space-between'
                        }}
                    >
                        {branchName && (
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <span style={{ fontSize: 11, color: '#6B7280', textTransform: 'uppercase', fontWeight: 600, letterSpacing: '0.05em' }}>Branch</span>
                                <strong style={{ fontSize: 15, color: '#111827', marginTop: 2 }}>{branchName}</strong>
                            </div>
                        )}
                        {shiftName && (
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <span style={{ fontSize: 11, color: '#6B7280', textTransform: 'uppercase', fontWeight: 600, letterSpacing: '0.05em' }}>Shift</span>
                                <strong style={{ fontSize: 15, color: '#111827', marginTop: 2 }}>{shiftName}</strong>
                            </div>
                        )}
                        {technicianName && (
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                                <span style={{ fontSize: 11, color: '#6B7280', textTransform: 'uppercase', fontWeight: 600, letterSpacing: '0.05em' }}>Technician</span>
                                <strong style={{ fontSize: 15, color: '#111827', marginTop: 2 }}>{technicianName}</strong>
                            </div>
                        )}
                    </div>
                </Grid>
            )}

            <Grid item xs={12} sm={6}>
                <FormLabel required className="mandatoryfields">
                    Start Date
                </FormLabel>
                <DatePicker name="startDate" value={state.startDate} onChange={handleInput} fullWidth />
                {errors.startDate && <FormHelperText error>{errors.startDate}</FormHelperText>}
            </Grid>

            <Grid item xs={12} sm={6}>
                <FormLabel required className="mandatoryfields">
                    End Date
                </FormLabel>
                <DatePicker name="endDate" value={state.endDate} onChange={handleInput} fullWidth />
                {errors.endDate && <FormHelperText error>{errors.endDate}</FormHelperText>}
            </Grid>

            <Grid item xs={12} container justify="flex-end" spacing={1} style={{ marginTop: '16px' }}>
                <Grid item xs={6}>
                    <SecondaryButton fullWidth onClick={() => onClose(false)}>
                        Cancel
                    </SecondaryButton>
                </Grid>
                <Grid item xs={6}>
                    <SecondaryButton fullWidth style={{ backgroundColor: '#EF4444', color: '#FFFFFF' }} onClick={handleUnassign} isBtnLoader={isBtnLoader}>
                        Unassign
                    </SecondaryButton>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default UnassignTechnicianModal;
